<template>
  <div class="contact-form px-l" :class="[formSent ? 'thanku' : '']">
    <i v-if="formSent" class="thanku-icon fal" :class="['fa-paper-plane']"></i>
    <h3 class="pb-2xl font-rg" v-html="title"></h3>
    <div v-if="!formSent" class="contact-form--fields">
      <div class="contact-form--field">
        <input
          id="firstName"
          type="text"
          v-model="firstName"
          @focus="validations.firstName.valid = true"
          :class="{ filled: firstName, invalid: !validations.firstName.valid }"
          required
        />
        <label
          for="firstName"
          v-text="`${localize('form_first_name')} *`"
        ></label>
        <span
          v-if="!validations.firstName.valid"
          class="err"
          v-text="validations.firstName.msg"
        ></span>
      </div>
      <div class="contact-form--field">
        <input
          id="lastName"
          type="text"
          v-model="lastName"
          :class="{ filled: lastName }"
        />
        <label for="lastName" v-text="`${localize('form_last_name')}`"></label>
      </div>
      <div class="contact-form--field">
        <input
          id="email"
          type="email"
          v-model="email"
          @focus="validations.email.valid = true"
          :class="{ filled: email, invalid: !validations.email.valid }"
          required
        />
        <label for="email" v-text="`${localize('form_email')} *`"></label>
        <span
          v-if="!validations.email.valid"
          class="err"
          v-text="validations.email.msg"
        ></span>
      </div>
      <div class="contact-form--field">
        <input
          id="phone"
          type="phone"
          v-model="phone"
          :class="{ filled: phone }"
          required
        />
        <label for="phone" v-text="`${localize('form_phone')}`"></label>
      </div>
      <div class="contact-form--field">
        <input
          id="country"
          type="text"
          v-model="country"
          :class="{ filled: country }"
        />
        <label for="country" v-text="`${localize('form_country')}`"></label>
      </div>
      <div v-if="localeString === 'en-us'" class="contact-form--field">
        <input id="zip" type="text" v-model="zip" :class="{ filled: zip }" />
        <label for="zip" v-text="`Zip Code`"></label>
      </div>
      <div class="contact-form--field contact-form--field__textarea">
        <textarea
          id="message"
          type="text"
          v-model="message"
          :class="{ filled: message }"
        />
        <label for="message" v-text="`${localize('form_msg')}`"></label>
      </div>
      <div :class="['contact-form--field', 'checkbox']">
        <input
          ref="solicitCheck"
          id="solicit"
          v-model="solicit"
          type="checkbox"
        />
        <!-- <label for="solicit" v-text="isMobile ? 'MIS\'ten güncellemeler almak istiyorum' : 'Ürünler ve hizmetler, özel teklifler, haberler ve etkinlikler hakkında güncellemeler almak istiyorum.'"></label> -->
        <label
          class="static"
          for="solicit"
          v-text="localize('form_check_updates')"
        ></label>
      </div>
    </div>
    <abtn
      v-if="!formSent"
      @click.native.prevent="submit"
      color="blue"
      :class="['self-end mt-xl']"
      :loading="sending"
      mini
    >
      <span v-text="localize('submit')"></span>
    </abtn>

    <ul v-if="submitErrors.length" class="err-log p-xl my-xl">
      <li v-for="err in submitErrors" :key="err.errorType">
        <i class="fal fa-exclamation-circle mr-xs"></i>
        <span v-text="err.message"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      formSent: false,

      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      country: "",
      zip: "",
      message: "",
      solicit: false,
      // eslint-disable-next-line
      email_rx: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      validations: {
        firstName: {
          valid: true,
          msg: "* Field is required"
        },
        lastName: {
          valid: true,
          msg: "* Field is required"
        },
        email: {
          valid: true,
          msg: "* Field is required"
        }
      },
      submitErrors: [],
      sending: false,
      formIds: //taken from the config file
      {
        en: "1656ddad-8fd8-4f34-881d-8a4b72cedf53",
        "en-us": "d23f66f4-ca2f-4523-8b67-b1b116d4bd56",
        "de-de": "103259bf-5223-4f80-b82a-f55e9ebdf74e",
        "fr-fr": "70a98666-3e69-4b3d-a657-618ed6433cb9",
        "es-es": "ef3e0b9a-b891-4190-bf70-7129698cdf15",
        "tr-tr": "4632a5ea-2415-48eb-9082-01024ac073de"
      }
    };
  },
  methods: {
    submit() {
      this.sending = true;
      if (this.formIsValid()) {
        // console.log("FORM is valid");
        // SUBMIT TO HUBSPOT
        this.submitFormToHubspot();
      } else {
        // console.log("FORM is NOT valid");
        this.sending = false;
      }
    },
    formIsValid() {
      let v = this.validations;
      v.firstName.valid = true;
      // v.lastName.valid = true;
      v.email.valid = true;
      if (!this.firstName) {
        this.$set(v.firstName, "valid", false);
      }
      // if (!this.lastName) {
      //   this.$set(v.lastName, "valid", false);
      // }
      if (!this.email) {
        this.$set(v.email, "valid", false);
        // this.$set(v.email, 'msg', '* Bereich ist obligatorisch');
      } else if (!this.email_rx.test(this.email)) {
        // console.log("EMAIL not valid > ", v.email);
        this.$set(v.email, "valid", false);
        this.$set(v.email, "msg", "Please enter valid email");
      }
      return !_.reject(v, "valid").length;
    },
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },    
    getFormID()
    {
      var vm =this;
      //let formId = this.formIds[this.localeString]; //v1
      
			let localeItem = _.filter(APP_CONFIG.APP_REGIONS, function(o){ 
				return o.locale == vm.localeString; 
			});

      let formId = "";
			if(localeItem && localeItem.length>0)
      {				
				formId = localeItem[0].hsform_id;
				console.log("formId => "+formId);
      }

      return formId;
      
    },
    async submitFormToHubspot() {
      this.sending = true;
      let hutk = this.getCookie("hubspotutk");
      let vm = this;
      let formId = this.getFormID() || "en"; 
      //alert("formId  x=>"+formId);return false;/////

      let _HUBSPOTURL = `https://api.hsforms.com/submissions/v3/integration/submit/3835094/${formId}`;

      // console.log("_HUBSPOTURL >> ", _HUBSPOTURL);
      let data = {
        submittedAt: new Date().getTime(),
        fields: [
          {
            name: "firstname",
            value: this.firstName
          },
          {
            name: "lastname",
            value: this.lastName
          },
          {
            name: "email",
            value: this.email
          },
          {
            name: "phone",
            value: this.phone
          },
          {
            name: "country",
            value: this.country
          },
          {
            name: "message",
            value: this.message
          },
          {
            name: "LEGAL_CONSENT.subscription_type_4847424",
            value: this.solicit
          }
        ],
        context: {
          pageUri: "https://www.mis-implants.com",
          pageName: "MIS Global Website"
        },
        skipValidation: false
      };
      if (this.localeString === "en-us") {
        data.fields.push({
          name: "zip",
          value: this.zip
        });
      }
      if (hutk) {
        data.context["hutk"] = hutk;
      }
      vm.$set(vm, "submitErrors", []);
      fetch(_HUBSPOTURL, {
        method: "POST",
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
          // 				'Access-Control-Allow-Origin': '*'
        },
        // redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *client
        body: JSON.stringify(data) // body data type must match "Content-Type" header
      })
        .then(function(response) {
          // console.log("FIRST THEN RESPONSE  < ", response);
          return response.json();
        })
        .then(
          async function(json) {
            // console.log("response from hubspot submit >> ", json);
            vm.sending = false;

            if (json.status && json.status && json.status === "error") {
              // console.log("[fetch|error] register user >> ", json);
              vm.$set(vm, "submitErrors", json.errors);
              throw new Error(json.message);
            } else {
              vm.formSent = true;
              let box = document
                .querySelector(".contact-form")
                .getBoundingClientRect();
              let top = box.top + window.scrollY - 146;
              window.scrollTo({ top, behavior: "smooth" });

              // vm.title =
              //   "Thank you for contacting us. We will get back to you shortly.";
            }
          },
          error => {
            vm.sending = false;
            // console.log("[fetch|error] register user >> ", error);
            throw new Error(error);
          }
        );
    }
  },
  computed: {
    ...mapGetters(["localeString"]),
    title() {
      return !this.formSent
        ? this.localize("send_us_msg")
        : this.localize("contact_thanks");
    }
  }
};
</script>


<style lang="stylus" scoped>
.err-log
  background rgba(red_3, 0.3)
  li:not(:last-child)
    marg('s', bottom)
  i
  span
    color red_6

.thanku-icon
  font-size responsive 30px 50px
  display block
  margin 20px auto 40px
.contact-form
    background gray_1
    padding-top 5vh
    padding-bottom 5vh
    min-width 200px
    +below(600px) //dubi
      padding-left 8.5vw
      padding-right 8.5vw
    _flex(column, wrap, stretch, center)
    &--field
        position relative
        height 40px
        marg('xl',bottom)
        clear: fix;
        +below(415px)
          height 30px
        &__textarea
          padding-top 20px
          height 120px
          +below(415px)
            height 80px
        .err
          color red_4
          float right
        label:not(.static)
            position absolute
            left 0
            top 0
            transform translateY(10px)
            font-size responsive 16px 20px
            transition transform 0.3s ease-out-cubic, font-size 0.3s ease-out-cubic
        input:not([type='checkbox'])
        textarea
            border none
            background none
            height 100%
            width 100%
            border-bottom 1px solid gray_3
            transition border 0.3s ease-out-cubic
            appearance none
            border-radius none
            &:focus
            &.filled
                border-bottom 1px solid blue_3
                outline 0
                & + label
                    transform translateY(-15px)
                    font-size 86%
            &.invalid
                border-bottom 1px solid red_3
        input[type='checkbox']
          float left
          & + label
            overflow hidden
            display block
</style>
